import { makeStyles } from '@material-ui/core';

// Stacked layout: shuttle image fills the sidebar column width, wordmark
// underneath. Pushes the search bar + nav items down the column naturally
// (Sidebar is a flex column).
const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '8px 4px 12px',
    gap: 8,
  },
  shuttle: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    display: 'block',
  },
  wordmark: {
    fontFamily: 'inherit',
    fontWeight: 700,
    fontSize: '2.2em',
    letterSpacing: '0.02em',
    color: '#FFFFFF',
    lineHeight: 1,
    whiteSpace: 'nowrap',
    width: '100%',
    textAlign: 'center',
  },
  // Silk product family lockup convention: "Silk" + fuchsia dot + suffix.
  dot: {
    color: '#FF286E',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img src="/shuttle.png" alt="Silk.Shuttle" className={classes.shuttle} />
      <span className={classes.wordmark}>
        Silk<span className={classes.dot}>.</span>Shuttle
      </span>
    </div>
  );
};
